




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import dataProxy from '@/services/data-proxy.service';
import {OrganizacionaJedinica} from "@/services/BackendProxies";

@Component({})
export default class SkladistaEditor extends Vue {
    organizacioneJedinice = [];
    @Prop() value!: string;
    @Prop({default: false}) invalid!: boolean;

    model = '';

    @Watch('value') onValueChanged(value: string) {
        this.model = value;
    }

    @Watch('model') onModelChanged(value) {
        this.input(value);
    }

    async created() {
        const organizacioneJedinice = this.organizacioneJedinice = await dataProxy.vratiSkladista();
        organizacioneJedinice.unshift(OrganizacionaJedinica.fromJS({id: '', naziv: '...'}));
        this.organizacioneJedinice = organizacioneJedinice.map(oj => ({id: oj.id, text: oj.naziv}));
        this.model = this.value;
    }

    @Emit() input(value: string | number) {
    }
}
